import Shared from 'emun.cart/cart.controller'
import resolve from 'ioc/resolve'
import templateUrl from 'emun.cart/cart-item-entry.htm'

class CartItemEntryController extends Shared{
    constructor ($cart) {
        super($cart)
        let $stateParams = resolve('$stateParams');
        if ($stateParams.cartId) $cart.load($stateParams.cartId);
    }
}

let CartItemEntry = {
    controller: CartItemEntryController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};

export default CartItemEntry;